function getDriverNotificationTypes() {
  return { FORGOT_PASSWORD: 'forgot_password' };
}

const driverUploadTypes = {
  ERP: 1,
  MANUAL: 2,
};

module.exports = { getDriverNotificationTypes, driverUploadTypes };
